import { GET, POST } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";

export const getFieldsType = () => {
  return GET("request/admin/service/fields-type").pipe(map((res: any) => res));
};

export const getTemplateTicket = () => {
  return GET("request/admin/service/templates-ticket").pipe(
    map((res: any) => res)
  );
};

export const postTemplateTicket = (data: any) => {
  return POST("request/admin/service/templates-ticket", data).pipe(
    map((res: any) => res)
  );
};

export const deleteTemplateTicket = (ids: any) => {
  return POST("request/admin/service/templates-ticket/delete", ids).pipe(
    map((res: any) => res)
  );
};

export const getTemplateTicketFields = () => {
  return GET("request/admin/service/templates-field").pipe(
    map((res: any) => res)
  );
};

export const postTemplateTicketFields = (data: any) => {
  return POST("request/admin/service/templates-field", data).pipe(
    map((res: any) => res)
  );
};

export const deleteTemplateTicketFields = (data: any) => {
  return POST("request/admin/service/templates-field/delete", data).pipe(
    map((res: any) => res)
  );
};

export const getServiceReq = () => {
  return GET("request/service/all").pipe(map((res: any) => res));
};

export const postServiceRequest = (data: any) => {
  return POST("request/admin/service", data).pipe(map((res: any) => res));
};

export const deleteServiceRequest = (ids: any) => {
  return POST("request/admin/service/delete", ids).pipe(map((res: any) => res));
};

export const getServiceReqFields = () => {
  return GET("request/admin/service/fields").pipe(map((res: any) => res));
};

export const postServiceReqFields = (data: any) => {
  return POST("request/admin/service/fields", data).pipe(
    map((res: any) => res)
  );
};

export const deleteServiceReqFields = (ids: any) => {
  return POST("request/admin/service/fields/delete", ids).pipe(
    map((res: any) => res)
  );
};

export const getExternalFields = () => {
  return GET("request/admin/service/fields-external-list").pipe(
    map((res: any) => res)
  );
};

export const postExtFields = (data: any) => {
  return POST("request/admin/service/fields-external-list", data).pipe(
    map((res: any) => res)
  );
};

export const deleteExtFields = (ids: any) => {
  return POST("request/admin/service/fields-external-list/delete", ids).pipe(
    map((res: any) => res)
  );
};
